import React from 'react';
import { Link } from 'react-router-dom';
import '../index.css'
// import './Navbar.css';

interface NavbarProps 
{
  isOpen: boolean;
  toggleSideBar: () => void;
  logout:()=>void;
}

const Navbar: React.FC<NavbarProps> = ({ isOpen, toggleSideBar, logout }) => {
  return (
    <div>
      <div className="fixed w-screen h-14 bg-white border-b border-[#dcdedf] top-0 left-0 z-[1100] flex items-center px-4">
        <button className="text-[#2d2d2d] bg-transparent border-none cursor-pointer font-bold text-[28px]" onClick={toggleSideBar}>
          { isOpen && 
            <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="ds-app-header__expand-icon">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16 1.6H0V0h16v1.6zM16 7.2H0V5.6h16v1.6zM16 12.8H0v-1.6h16v1.6z" fill="#3E3E3E"></path>
            </svg>
          }
          { !isOpen &&
            <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="ds-app-header__collapse-icon">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.2H0V5.6h16v1.6zM12 1.6H0V0h12v1.6zM8 12.8H0v-1.6h8v1.6z" fill="#3E3E3E"></path>
            </svg>
          } 
        </button>
        <div className="pl-4">
          <svg width="86" height="20" viewBox="0 0 86 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="ds-app-header__wrkspot-logo">
                <g clip-path="url(#wrkspot-logo_svg__clip0_5423_63216)"><path d="M23.464 15.298H20.7V4.042h2.644v2.393c.45-.882 1.66-2.393 3.36-2.393h.389v3.02c-.124-.059-.41-.097-.574-.097-1.865 0-3.052 1.334-3.052 2.275v6.058h-.002zM33.003 10.338l-1.312 1.235v3.725h-2.765V1.315L31.69 0v8.179l4.386-4.137h3.565l-4.712 4.47 4.999 6.786h-3.36l-3.566-4.96zM9.8 4.983L6.974 15.298H3.776L0 1.315 2.793.002 5.56 11.298 8.305.002h3.156l2.725 11.315L16.971.002h2.91l-4.138 15.296h-3.197L9.8 4.983z" fill="#A063A6"></path>
                  <path d="M49.366 3.257c-.717-.275-1.824-.471-2.725-.471-1.7 0-2.397.549-2.397 1.393 0 .785.8 1.431 2.663 2.668 2.234 1.49 3.606 2.765 3.606 4.55 0 2.413-2.212 4.14-5.553 4.14-1.025 0-2.787-.237-3.523-.453l.041-2.568c.697.255 2.336.608 3.667.608 1.58 0 2.357-.764 2.357-1.609 0-.804-.82-1.49-2.683-2.706-2.684-1.764-3.546-2.942-3.546-4.61 0-1.96 1.557-3.824 5.37-3.824.943 0 2.008.157 2.765.353l-.042 2.529zM54.673 13.867v5.747h-2.767V4.042h2.624v1.53c1.127-1.176 2.787-1.902 4.732-1.902 3.402 0 5.982 2.649 5.982 5.963 0 3.315-2.582 6.04-5.982 6.04-1.841-.002-3.46-.707-4.589-1.806zm3.832-.509c2.234 0 3.833-1.686 3.833-3.668 0-1.982-1.599-3.706-3.833-3.706-2.233 0-3.913 1.726-3.913 3.687 0 1.98 1.68 3.687 3.913 3.687zM79.793 9.67c0 3.433-2.889 6.198-6.822 6.198-3.914 0-6.823-2.765-6.823-6.197s2.91-6.197 6.823-6.197c3.933-.002 6.822 2.763 6.822 6.197zm-10.736 0c0 2.177 1.66 3.943 3.914 3.943 2.273 0 3.933-1.785 3.933-3.942 0-2.176-1.66-3.943-3.933-3.943-2.256 0-3.914 1.765-3.914 3.943zM84.523 6.277v9.021h-2.767V6.277h-1.475V4.042h1.475V1.315l2.767-.589v3.316H86v2.235h-1.475z" fill="#13478F"></path>
                </g>
                <defs>
                  <clipPath id="wrkspot-logo_svg__clip0_5423_63216">
                    <path fill="#fff" transform="translate(0 .193)" d="M0 0h86v19.614H0z"></path>
                  </clipPath>
                </defs>
          </svg>
        </div>
        <div className="ml-auto">
          <button className="ml-4 text-right text-[#2d2d2d] text-[15px] font-medium hover:text-[#1c69d4]  border border-gray-400 bg-white rounded-[3px] p-[6px]" onClick={logout}>Logout</button>
        </div>
      </div>
    <div className={`sidebar group fixed p-4 text-[#2d2d2d] bg-white transition-[width] duration-300 border-r border-[#dcdedf] z-[1000] top-0 left-0 h-screen ${isOpen ? 'shifted w-[150px]' : 'collapsed w-[50px] hover:w-[150px]'}`}>
    <div className="pt-[40px] mt-5">
          <ul className="list-none">
            <li className='mb-2'>
              <Link to="/" className="text-[#2d2d2d] text-base hover:text-[#1c69d4]">
              <div className="flex items-center space-x-2 flex-row h-[24px] hover:text-[#1c69d4]">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="transition-colors duration-200 flex-shrink-0 hover:text-[#1c69d4]">
                    <g clip-path="url(#dashboard_svg__clip0_5656_64285)" fill-rule="evenodd" clip-rule="evenodd" fill="#3E3E3E">
                      <path d="M10.037.45l.8.004a8.746 8.746 0 018.709 8.755l-.001.795h-9.508V.451zm1.592 1.644v6.319h6.282a7.154 7.154 0 00-6.282-6.319z"></path>
                      <path d="M7.612 5.28a6.363 6.363 0 104.689 11.345L7.612 11.92V5.279zM13.428 15.5a6.363 6.363 0 001.293-3.113h-4.396l3.103 3.113zm-4.22-4.234v-.471h7.155v.796a7.954 7.954 0 11-7.955-7.954h.796v7.625l.004.004z"></path>
                    </g>
                    <defs>
                      <clipPath id="dashboard_svg__clip0_5656_64285">
                        <path fill="#fff" d="M0 0h20v20H0z"></path>
                      </clipPath>
                    </defs>
                  </svg>
                  <span
              className={`whitespace-nowrap overflow-hidden transition-all duration-300 ${
                isOpen ? 'inline' : 'hidden group-hover:inline'
              }`}
            >Dashboard
            </span>
                </div>
              </Link>
            </li>
          </ul>
        </div>
    </div>
    </div>
  );
};

export default Navbar;


